export const round = (value, step = 1.0) => {
    const inv = 1.0 / step;
    return Math.round(value * inv) / inv;
};
export const range = (start, end) => new Array(end + 1 - start).fill('').map((_, i) => i + start);
